export default {
      id: "assurance-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#assurance",
      toString: function () {
        return this.url;
      }
    }